import { useEffect, useState } from "react";
import { ProgramType } from "data/programData";
import * as _ from "lodash";
import { getReferenceData } from "logic/logics";
import { ProgramContentType } from "data/BlockComponent";
import { useRecoilValue } from "recoil";
import { taskListAtom } from "recoil/taskListAtom";
import {
  ThoughtRecordTemplate_U0,
  ThoughtRecordTemplate_U1,
  ThoughtRecordTemplate_U2,
  ThoughtRecordTemplate_U3,
} from "data/task/2-2-T";
import useGetProgramData from "./useGetProgramData";
import useGetThoughtmapState from "./useGetThoughtMapState";
import { isDev } from "config";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";

export default function useGetBlankThoughtRecordData({
  trk,
  isFirst,
}: {
  trk?: string;
  isFirst?: boolean;
}) {
  const taskId = "2-2-T";
  const [data, setData] = useState<ProgramType>();

  const taskListState = useRecoilValue(taskListAtom);

  const thoughtTrapNumList = isDev
    ? ["1", "2", "3", "4", "5", "6"]
    : taskListState
        .filter(
          (element) => element.taskId.startsWith("4-5") && element.lastDoneAt
        )
        .map((each) => each.taskId.split("-")[2]);

  const isUpgraded = taskListState.some(
    (element) => element.taskId.startsWith("4-5") && element.lastDoneAt
  );
  const isUpgraded2 = taskListState.some(
    (element) => element.taskId.startsWith("5-5-A") && element.lastDoneAt
  );
  const isUpgraded3 = taskListState.some(
    (element) => element.taskId === "6-9-A" && element.lastDoneAt
  );

  const thoughtRecordTaskData = useGetProgramData(taskId);
  const thoughtmapState = useGetThoughtmapState();

  useEffect(() => {
    let rawData = _.cloneDeep(thoughtRecordTaskData);

    if (trk && rawData) {
      if (isUpgraded3) {
        rawData.content = _.cloneDeep(
          ThoughtRecordTemplate_U3(
            thoughtTrapNumList,
            thoughtmapState?.coreBeliefKeyList
          )
        );
      } else if (isUpgraded2) {
        rawData.content = _.cloneDeep(
          ThoughtRecordTemplate_U2(thoughtTrapNumList)
        );
      } else if (isUpgraded) {
        rawData.content = _.cloneDeep(
          ThoughtRecordTemplate_U1(thoughtTrapNumList)
        );
      } else if (!isFirst) {
        rawData.content = _.cloneDeep(ThoughtRecordTemplate_U0);
      }

      (rawData.content as ProgramContentType[])[0].lines.push([
        {
          type: "temp",
          content: {
            id: `thoughtRecordKey`,
            value: trk,
          },
        },
      ]);

      setData(setDataWithEditorKeyAndTranslationVersion(rawData));
    }
  }, [trk]);

  return data;
}
